
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 431.616 431.616"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M411.392 35.84H326.4V0h-30.72v35.84H135.936V0h-30.72v35.84H20.224c-8.704 0-15.36 6.656-15.36 15.36v365.056c0 8.704 6.656 15.36 15.36 15.36h391.168c8.704 0 15.36-6.656 15.36-15.36V51.2c0-8.192-6.656-15.36-15.36-15.36zM109.824 352.768c-16.896 0-30.208-13.312-30.208-30.208s13.312-30.208 30.208-30.208 30.208 13.312 30.208 30.208-13.312 30.208-30.208 30.208zm0-90.112c-16.896 0-30.208-13.312-30.208-30.208s13.312-30.208 30.208-30.208 30.208 13.312 30.208 30.208-13.312 30.208-30.208 30.208zm105.984 90.112c-16.896 0-30.208-13.312-30.208-30.208s13.312-30.208 30.208-30.208 30.208 13.312 30.208 30.208c0 16.384-13.312 30.208-30.208 30.208zm0-90.112c-16.896 0-30.208-13.312-30.208-30.208s13.312-30.208 30.208-30.208 30.208 13.312 30.208 30.208c0 16.384-13.312 30.208-30.208 30.208zm105.984 90.112c-16.896 0-30.208-13.312-30.208-30.208s13.312-30.208 30.208-30.208S352 305.664 352 322.56s-13.312 30.208-30.208 30.208zm0-90.112c-16.896 0-30.208-13.312-30.208-30.208s13.312-30.208 30.208-30.208S352 215.552 352 232.448s-13.312 30.208-30.208 30.208zm74.24-141.824v6.144H35.584V66.56h69.632v36.864h30.72V66.56H295.68v36.864h30.72V66.56h69.632v54.272z"}})])
          )
        }
      }
    